<template>
  <d-container
    fluid
    class="main-content-container px-4">
    <!-- Page Header -->
    <d-row
      no-gutters
      class="page-header py-4">
      <d-col
        col
        sm="6"
        class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Kategorie produktów</span>
        <h3 class="page-title">Lista kategorii</h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="success"
          class="text-nowrap"
          @click.prevent="$router.push('/kategorie/nowy')">
          <i class="material-icons">add</i>
          Dodaj kategorię
        </d-button>
      </d-col>
    </d-row>

    <d-row
      class="d-flex ml-0 mb-3 page-filters w-100">
      <validation-observer
        ref="categories-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <d-input
          placeholder="Podaj nazwę kategorii"
          v-model="filters.search" />
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>

        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th
              scope="col"
              class="border-0"
              width="150px">Kolejność</th>
            <th
              scope="col"
              class="border-0">Nazwa</th>
            <th
              scope="col"
              class="border-0 text-center"
              width="140">Akcje</th>
          </tr>
        </thead>
        <tbody v-if="categories">
          <tr
            v-for="(category, index) of categories"
            :key="'user-' + index">
            <td class="align-middle">
              {{ category.ordering }}
            </td>
            <td class="align-middle">
              {{ category.name }}
            </td>
            <td
              class="align-middle text-center d-flex justify-content-center"
              style="gap: 12px;">
              <d-button
                theme="primary"
                @click.native="$router.push('/kategorie/edycja/' + category.id)"
                class="mr-2 action-button"
                title="Edytuj">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                class="action-button"
                theme="danger"
                @click.native="removeCategory(category.id)"
                title="Usuń">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="categories.length === 0">
            <td
              colspan="5"
              class="text-center">
              Brak kategorii do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div
        v-if="!categories"
        class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="load_error"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a
          href="javascript:window.location.reload();"
        class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>
    <pagination
      :meta-data="paginationMetaData"
      :initial-page="currentPage"/>

  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../utils/FormUtils.js';
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';

export default {
  name: 'categories',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  data () {
    return {
      categories: [],
      loaded: false,
      removeInProgress: false,
      load_error: false,
      filters: {
        search: '',
      }
    };
  },
  mounted () {
    this.loadFilteredData();
  },
  methods: {
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = {
        search: this.filters.search
      };
      ListUtils.loadItemsData(this, {
        endpoint: '/categories/items',
        listField: 'categories',
        errorKey: 'load_error',
        pagination: true,
        params: {
          where,
          order: {
            column: 'ordering',
            direction: 'ASC'
          }
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.load_error = false;
      this.filters = {
        search: ''
      };

      this.loadFilteredData();
      this.$bus.$emit('view-filters-reset');
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['categories-filters-form'], this.debouncedLoadFilteredData);
    },
    removeCategory (categoryID) {
      ListUtils.removeItem(this, {
        endpointBase: '/categories/delete/',
        id: categoryID,
        successTitle: 'Usunięto kategorię',
        successText: 'Wybrana kategoria została usunięty',
        confirmTitle: 'Czy na pewno chcesz usunąć tą kategorię?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie kategorii nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>

